
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/_guards/auth.guard';
import { CustomerReportComponent } from './customer-report.component';


const routes: Routes = [
    { path: 'customerReport', pathMatch: 'full', component:  CustomerReportComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerReportoutingModule { }


// WEBPACK FOOTER //
// ./src/app/customer-report/customer-report-routing.module.ts